import React, { useContext } from "react";
import { ComponentContext } from '../../contexts/ComponentContext';

const SvgHeader = (props) => {
  const [component, setComponent] = useContext(ComponentContext);

  const handleClick = (nb) => {
    setComponent( { id: nb } );
  }
  const handleNext = () => {
    let newId = ((component.id)+1 < 4 ? (component.id)+1 : 0);
    setComponent( { id: newId } );
  }
  const handlePrev = () => {
    let newId = ((component.id)-1 >= 0 ? (component.id)-1 : 3);
    setComponent( { id: newId } );
  }

  return (
    <header className={`header active active${component.id}`} >
      <svg  {...props} viewBox="0 0 1236.346 190.338" preserveAspectRatio="xMinYMin meet">
        <defs>
          <clipPath id="header_svg__a">
            <path fill="none" d="M0 0h26.346v21.338H0z" />
          </clipPath>
        </defs>
         <g data-name="Groupe 1900">
          <path
            data-name="Trac\xE9 4877"
            d="M74.136 67V18.6H1156.8V67"
            fill="none"
            stroke="#707070"
            strokeWidth={2}
            strokeDasharray={3}
          />
          
          <path data-name="Rectangle 321" fill="#fff" d="M376 0h98v32h-98z" />
          <path data-name="Rectangle 322" fill="#fff" d="M503 0h131v64H503z" />
          <path data-name="Rectangle 323" fill="#fff" d="M665 0h60v32h-60z" />
          <path data-name="Rectangle 324" fill="#fff" d="M851 0h156v32H851z" />
          <rect
            data-name="Ligne indic"
            className="indicateur"
            opacity={1}
            stroke="#8D0687"
            strokeWidth={3}
            fill="#fff"
    
            height=".1"
            x="50"
            y="158.5"
          
          />

          { 
          /* 
          M49.5 158.857h20
          M49.5 158.857h370
          M49.5 158.857h640
          M49.5 158.857h1120 
          */}
          <path
            data-name="Ligne 27409"
            opacity={0.36}
            stroke="#191919"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            fill="#fff"
            d="M49.5 158.857h1142"
          />
          
      <g id="Oval_2" fill="#8d0687" stroke="#8d0687" strokeMiterlimit="10" strokeWidth="3" transform="translate(1506.23 1674.88)" data-name="Oval 2">
        <circle stroke="none" cx="6.991" cy="6.991" r="6.991" />
        <circle fill="none" cx="6.991" cy="6.991" r="5.491" />
      </g><g id="Oval_3" fill="none" stroke="#8d0687" strokeMiterlimit="10" strokeWidth="1" transform="translate(1488 1657.65)" data-name="Oval 3">
        <circle stroke="none" cx="25.225" cy="25.225" r="25.225" />
        <circle fill="none" cx="25.225" cy="25.225" r="24.725" />
      </g>
          <g
            className=""
            data-name="Oval 2 Copy"
            transform="translate(67.145 151.883)"
            fill="#fff"
            stroke="#9b9b9b"
            strokeMiterlimit={10}
            strokeWidth={3}
            // onClick= {() => handleClick(0) } 
          >
            <g className="round0_active">
                <circle cx={6.991} cy={6.991} r={25.491} strokeWidth="1" stroke="#8D0687" fill="none" />
               <circle cx={6.991} cy={6.991} r={5.491} stroke="none" fill="#8D0687" />
            </g>
            <g className="round0_default">
              <circle cx={6.991} cy={6.991} r={6.991} stroke="none" />
              <circle cx={6.991} cy={6.991} r={5.491} fill="none" />
            </g>
            
          </g>
          <g
            className="round1"
            data-name="Oval 2 Copy 3"
            transform="translate(416.307 151.883)"
            fill="#fff"
            stroke="#9b9b9b"
            strokeMiterlimit={10}
            strokeWidth={3}
            onClick= {() => handleClick(1) } 
          >
            <g className="round1_active">
                <circle cx={6.991} cy={6.991} r={25.491} strokeWidth="1" stroke="#8D0687" fill="none" />
               <circle cx={6.991} cy={6.991} r={5.491} stroke="none" fill="#8D0687" />
            </g>
            <g className="round1_default">
              <circle cx={6.991} cy={6.991} r={6.991} stroke="none" />
              <circle cx={6.991} cy={6.991} r={5.491} fill="none" />
            </g>
          </g>
          <g
            className="round3"
            data-name="Oval 2 Copy 4"
            transform="translate(1160.218 151.883)"
            fill="#fff"
            stroke="#9b9b9b"
            strokeMiterlimit={10}
            strokeWidth={3}
            onClick= {() => handleClick(3) } 
          >
            <g className="round3_active">
                <circle cx={6.991} cy={6.991} r={25.491} strokeWidth="1" stroke="#8D0687" fill="none" />
               <circle cx={6.991} cy={6.991} r={5.491} stroke="none" fill="#8D0687" />
            </g>
            <g className="round3_default">
              <circle cx={6.991} cy={6.991} r={6.991} stroke="none" />
              <circle cx={6.991} cy={6.991} r={5.491} fill="none" />
            </g>
          </g>
          
          <g
            onClick= {() => handleNext() }
            data-name="Symbole 21 \u2013 16"
            transform="translate(1210 148)"
            opacity={0.82}
            clipPath="url(#header_svg__a)"
             
          >
            <g data-name="icons/arrow_right-black big copy">
              <path
                data-name="Combined Shape"
                d="M16.742 21.338l-1.484-1.341 7.525-8.329H0v-2h22.727l-7.471-8.33L16.745.002l9.6 10.708z"
                fill="#6c6c6c"
                stroke="#6c6c6c"
              />
            </g>
          </g>
          <g
            onClick = { () => { handlePrev() }}
            data-name="Symbole 21 \u2013 17"
            transform="rotate(180 13.173 84.669)"
            opacity={0.82}
            clipPath="url(#header_svg__a)"
          >
            <g data-name="icons/arrow_right-black big copy">
              <path
                data-name="Combined Shape"
                d="M16.742 21.338l-1.484-1.341 7.525-8.329H0v-2h22.727l-7.471-8.33L16.745.002l9.6 10.708z"
                fill="#6c6c6c"
                stroke="#6c6c6c"
              />
            </g>
          </g>
          <g
            className=""
            data-name="Oval 2"
            transform="translate(786.234 151.883)"
            fill="#8d0687"
            stroke="#8d0687"
            strokeMiterlimit={10}
            strokeWidth={3}
            onClick= {() => handleClick(2) } 
          >
            <g className="round2_active">
                <circle cx={6.991} cy={6.991} r={25.491} strokeWidth="1" stroke="#8D0687" fill="none" />
               <circle cx={6.991} cy={6.991} r={5.491} stroke="none" fill="#8D0687" />
            </g>
            <g className="round2_default">
              <circle cx={6.991} cy={6.991} r={6.991} stroke="none" />
              <circle cx={6.991} cy={6.991} r={5.491} fill="none" />
            </g>
          </g>
          <text
            data-name="changement d'échelle"
            transform="translate(511 24)"
            fill="#282828"
            fontSize={24}
            fontFamily="SolexBold"
            letterSpacing=".02em"
          >
            <tspan x={0} y={0}>
              {"CHANGEMENT"}
            </tspan>
            <tspan x={0} y={26}>
              {" D'ÉCHELLE"}
            </tspan>
          </text>
          <text
            data-name="g\xE9n\xE9ralisation"
            transform="translate(856 24)"
            fontSize={24}
            fontFamily="SolexBold"
            letterSpacing=".02em"
          >
            <tspan x={0} y={0}>
              {"G\xC9N\xC9RALISATION"}
            </tspan>
          </text>
          <text
            data-name="\xE9valuation"
            transform="translate(379 25)"
            fontSize={24}
            fontFamily="SolexBold"
            letterSpacing=".02em"
          >
            <tspan x={0} y={0}>
              {"\xC9valuation"}
            </tspan>
          </text>
          <text
            data-name="Bilan"
            transform="translate(673 25)"
            fontSize={24}
            fontFamily="SolexBold"
            letterSpacing=".02em"
          >
            <tspan x={0} y={0}>
              {"Bilan"}
            </tspan>
          </text>
          <path
            data-name="Trac\xE9 4878"
            d="M101.8 10l7.3 8.2-7.3 7.2"
            fill="none"
            stroke="#707070"
            strokeLinecap="round"
            strokeWidth={2}
          />
          <path
            data-name="Trac\xE9 4879"
            d="M1165.15 33.05l-8.2 7.3-7.2-7.3"
            fill="none"
            stroke="#707070"
            strokeLinecap="round"
            strokeWidth={2}
          />
          <path data-name="Rectangle 320" fill="#fff" d="M151 0h177v32H151z" />
          <text
            data-name="exp\xE9rimentations"
            transform="translate(155 24)"
            fill="#282828"
            fontSize={24}
            fontFamily="SolexBold"
            letterSpacing=".02em"
          >
            <tspan x={0} y={0}>
              {"EXP\xC9RIMENTATIONS"}
            </tspan>
          </text>
          <text
            className="link_inactive"
            data-name={2020}
            transform="translate(46 117)"
            fontSize={32}
            fontFamily="SolexBold"
            letterSpacing=".02em"
            // onClick= {() => handleClick(0) } 
          >
            <tspan x={0} y={0}>
              {"2020"}
            </tspan>
          </text>
          <text
            className="link"
            data-name={2030}
            transform="translate(395 117)"
            fontSize={32}
            fontFamily="SolexBold"
            letterSpacing=".02em"
            onClick= {() => handleClick(1) } 
          >
            <tspan x={0} y={0}>
              {"2030"}
            </tspan>
          </text>
          <text
            className="link_inactive"
            data-name={2040}
            transform="translate(764 117)"
            fontSize={32}
            fontFamily="SolexBold"
            letterSpacing=".02em"
            // onClick= {() => handleClick(2) }
          >
            <tspan x={0} y={0}>
              {"2040"}
            </tspan>
          </text>
          <text
            className="link"
            data-name={2050}
            transform="translate(1134 117)"
            fontSize={32}
            fontFamily="SolexBold"
            letterSpacing=".02em"
            onClick= {() => handleClick(3) }
          >
            <tspan x={0} y={0}>
              {"2050"}
            </tspan>
          </text>
          <g
            className=""
            data-name="Oval 2 Copy 3"
            transform="translate(786.308 151.883)"
            fill="#fff"
            stroke="#9b9b9b"
            strokeMiterlimit={10}
            strokeWidth={3}
            onClick= {() => handleClick(2) }
          >
            <circle cx={6.991} cy={6.991} r={6.991} stroke="none" />
            <circle cx={6.991} cy={6.991} r={5.491} fill="none" />
          </g>
        </g>
      </svg>
    </header>
  );
}

export default SvgHeader;
{
/*
 <Row className="subheader" wrap horizontal="spaced">
    <Column flex="1" ><span>expérimentations</span></Column>
    <Column flex="1" ><span>évaluation</span></Column>
    <Column flex="1" ><span>changement<br/>d'échelle</span></Column>
    <Column flex="2" ><span>généralisation</span></Column>
</Row>

<header className={`header active${active} `} >
    <Row wrap horizontal="spaced">
        <Column flex="1"  onClick= {() => this.handleClick(0) } className={ `${(active === 0 ? 'active':'')} cursor-pointer`}>
            2020   
        </Column>
        <Column flex="1"  onClick= {() => this.handleClick(1) } className={ `${(active === 1 ? 'active':'')} cursor-pointer`}>
            2025
        </Column>
        <Column flex="1"  onClick= {() => this.handleClick(2) } className={ `${(active === 2 ? 'active':'')} cursor-pointer`}>
            2030
        </Column>
        <Column flex="1"  horizontal="end" onClick= {() => this.handleClick(3) } className={ `${(active === 3 ? 'active':'')}  cursor-pointer`}>
            2050
        </Column>
    </Row>
    <div style={styleRep} className="rep" id="rep0"></div>
    <div style={styleRep} className="rep" id="rep1"></div>
    <div style={styleRep} className="rep" id="rep2"></div>
    <div style={styleRep} className="rep" id="rep3"></div>
</header>
*/
}